import { Flex, Text } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";
import { useProofsToApprove } from "../../../state/proofs-to-approve";
import { ApprobationView } from "./ApprobationView";

export { ApprobationById } from "./ApprobationById";

export function Approbation() {
  const { t } = useTranslation();
  const [proofs, , refreshProofs] = useProofsToApprove();

  const [nextProof] = proofs;

  if (!proofs.length) {
    return (
      <Flex
        p="4"
        justify="center"
        align="center"
        style={{ minHeight: "200px" }}
      >
        <Text color="gray" size="3">
          {t("approbation.noProofsPending")}
        </Text>
      </Flex>
    );
  }

  return (
    <ApprobationView
      proofId={nextProof.id}
      proofsLeft={proofs.length}
      onDecision={refreshProofs}
    />
  );
}
